module.exports = __webpack_public_path__ + "static/swan-11549e22091fcd04bd20ef0dc47ad8fb.png";